import { ActionReducerMap } from '@ngrx/store';
import * as HomeBuildingState from '@zayan-erp/stores';
import * as WarrantyState from '@zayan-erp/stores';
import * as SalesState from '../../../../../libs/stores/src/lib/sales-state/sales.reducer';
import * as ProductState from '@zayan-erp/stores';

export interface AppState {
  homeBuildingReducer: HomeBuildingState.HomeBuildingState;
  warrantyReducer: WarrantyState.WarrantyState;
  salesReducer: SalesState.SalesState;
  productReducer: ProductState.ProductState;
}

export const appReducers: ActionReducerMap<AppState> = {
  homeBuildingReducer: HomeBuildingState.homeBuildingReducer,
  warrantyReducer: WarrantyState.warrantyReducer,
  salesReducer: SalesState.salesReducer,
  productReducer: ProductState.productReducer
};
